const testimonials = [
  {
    name: "Robert Harmon",
    location: "Kingsport, TN",
    rating: 5,
    text: "I'm a senior engineer at Eastman Chemical and got called to our Singapore facility with 5 days' notice. My passport was expired. Fast Passport Center had a new one in my hands in 3 business days. Corporate travel is unpredictable — this service is a lifesaver.",
    service: "Rush — Eastman Singapore",
    initial: "RH",
  },
  {
    name: "Patricia Lawson",
    location: "Kingsport, TN",
    rating: 5,
    text: "My daughter is a BAE Systems contractor deploying to the UK for a defense project. We nearly missed the deadline because the post office lost her application. Fast Passport Center handled the emergency replacement in 48 hours. Cannot thank them enough.",
    service: "Emergency — BAE UK Deployment",
    initial: "PL",
  },
  {
    name: "James Whitfield",
    location: "Church Hill, TN",
    rating: 5,
    text: "I'm an Eastman operations manager and travel to Germany twice a year. Fast Passport Center is on my speed dial now. Renewal done in 4 days, shipped overnight, tracked every step. Best service I've found for Sullivan County professionals.",
    service: "Rush Renewal — Germany",
    initial: "JW",
  },
  {
    name: "Sandra Carter",
    location: "Kingsport, TN",
    rating: 5,
    text: "My entire family needed passports for a cruise to the Caribbean — three adults and two kids. The team walked us through the minor passport requirements, caught a photo issue before submission, and had all five passports back in 2 weeks. Amazing.",
    service: "Family Application — Caribbean Cruise",
    initial: "SC",
  },
  {
    name: "Michael Torres",
    location: "Gate City, VA",
    rating: 5,
    text: "Even though I'm across the state line in Gate City, Fast Passport Center made everything work remotely. My Eastman business passport renewal was handled entirely by mail and email. Professionally done.",
    service: "Renewal — Gate City VA",
    initial: "MT",
  },
  {
    name: "Dr. Angela Brown",
    location: "Kingsport, TN",
    rating: 5,
    text: "As a physician with Ballad Health, I attend international medical conferences every year. I count on Fast Passport Center for my renewals. They're reliable, fast, and they know the corporate timeline better than anyone.",
    service: "Rush Renewal — Medical Conference",
    initial: "AB",
  },
];

export default function KingsportTestimonialsSection() {
  return (
    <section id="testimonials" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Testimonials</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Kingsport Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From Eastman Chemical executives to BAE Systems contractors — here's what Sullivan County professionals say about our expedited passport services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-xl p-7 border border-gray-100 flex flex-col">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-lg"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] text-white text-sm font-bold flex-shrink-0">
                  {t.initial}
                </div>
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <div className="ml-auto">
                  <span className="text-xs bg-[#F6C344]/20 text-[#1A365D] font-medium px-2 py-1 rounded-full whitespace-nowrap">{t.service}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}